export default __webpack_public_path__ + "static/media/banner.4076d0a7.jpeg";